import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectUser from '@/views/Authorization/models/projectUser'
import UserAvatar from '@/_components/avatar/nuser/user.vue'

@Component({
    inheritAttrs: false,
    components: { UserAvatar },
})
export default class InlineUser extends Mixins<MixinInterface>() {
    @Prop({ required: true }) userName!: string
    @Prop({ required: true }) userId!: string
    @Prop({ required: true }) projectId!: string
    @Prop({ default: 'span' }) tag!: string

    menu = false

    user: null | ProjectUser = null

    error = false

    @Watch('menu')
    async getUser() {
        this.error = false
        if (!this.user) {
            this.user = await ProjectUser.getProjectUser(this.projectId, this.userId, false).catch(
                () => {
                    this.error = true
                }
            )
        }
    }
}
